import Instituicao from './Instituicao'

export const instituicaoRoutes = [
  { name: 'instituicao', path: '/instituicao', component: Instituicao }
]
